module.exports = __webpack_public_path__ + "static/media/nav-regulations-hover.484c9bc5.svg";